module.exports = "<p>\n  division-dept-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/division-department/division-dept-form/division-dept-form.component.html
// module id = ./src/app/ultilities/division-department/division-dept-form/division-dept-form.component.html
// module chunks = main